
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#F2994A"}}),_c('path',{attrs:{"d":"M8.769 9.944H7.128l-.232-6.897H9l-.232 6.897zm-.82 1.08c.332 0 .599.098.799.294a.994.994 0 01.308.752c0 .301-.103.55-.308.745-.2.196-.467.294-.8.294-.328 0-.594-.098-.8-.294a.997.997 0 01-.3-.745c0-.3.1-.549.3-.745.206-.2.472-.3.8-.3z","fill":"#fff"}})])
          )
        }
      }
    